<template>
  <div class="brands">
    <HeroBlock v-bind="hero"></HeroBlock>
    <div class="block">
      <CardBlock :cards="cards"></CardBlock>
      <DescriptionBlock v-bind="description"></DescriptionBlock>
      <LikeBlock v-bind="like"></LikeBlock>
    </div>
    <Toggle :cards="cards" :description="description" :like="like"></Toggle>
    <ComModal :promise="promise" style="padding-bottom: 80px"></ComModal>
    <Developing v-if="0"></Developing>
  </div>
</template>

<script>
import HeroBlock from "@/components/hero-block";
import CardBlock from "@/components/cards-block";
import DescriptionBlock from "@/components/description-block";
import LikeBlock from "@/components/like-block";
import Toggle from "@/components/toggle";
import ComModal from "@/components/commercial-modal";
import Developing from "../components/developing-block";
export default {
  components: {
    HeroBlock,
    CardBlock,
    DescriptionBlock,
    LikeBlock,
    Toggle,
    ComModal,
    Developing
  },
  data() {
    return {
      hero: {
        title: `Автоматизация акций в сети <br>
        ваших франчайзи`,
        paragraphs: [
          `Получите подробную информацию о ваших франчайзи: изучите аудиторию, <br>
          структуру продаж, результативность смен и многое другое.`,
          `Для старта акции не требуется дополнительного оборудования, <br>
          или перепрограммирования касс. Система работает через регистрацию <br>
          и распознавание чеков. Вы запускаете стимулирующубю акцию, или <br>
          программу лояльности, далее программа все делает сама.`,
          `CRM формирует как общую статистику, так и данные отдельно <br>
          по каждой франчайзи. Система составляет рейтинги торговых точек <br>
          и даже отдельных продавцов. При этом данные поступают напрямую <br>
          от конченых покупателей, без возможных искажений посредниками.`
        ],
        src: require(`@/assets/images/hero5.png`)
      },
      cards: [
        {
          title: `Действует по всей стране`,
          paragraph: `Для запуска единой акции по всем точкам продаж не требуется ни выпуска специальных карт, ни какого-то оборудования. <br>
          Поэтому вы быстро, легко и без лишних затрат, независимо от географии расположения ваших франчайзи, запустите <br>
          акцию с любой механикой.`,
          src: require(`@/assets/images/card-franchaisors1.svg`)
        },
        {
          title: `Уникальные исследования`,
          paragraph: `Непосредственные покупатели вашей продукции, участвуя в акциях, будут сами присылать вам ценнейшую <br>
          информацию о себе и ваших франчайзи, а программа сформирует её в подробные отчеты. Получая чеки и анкеты <br>
          от пользователей, система будет знать время, географию, состав покупок и даже фамилию продавца, и все это <br>
          в привязке к подробному портрету покупателя.`,
          src: require(`@/assets/images/card-franchaisors2.svg`)
        },
        {
          title: `Настраивается под разные задачи`,
          paragraph: `Регистрация чеков не всегда решает все задачи, которые поставил франчайзор перед маркетологом. К примеру, часто требуется
          собирать данные с упаковок товаров. Программа может быть настроена на распознавание специальных qr-кодов, штрих-кодов
          или промо-кодов.`,
          src: require(`@/assets/images/card-franchaisors3.svg`)
        },
        {
          title: `Мультиплатформа`,
          paragraph: `Для участия в акции участнику предлагается адаптивная веб-форма и полнофункциональный чат-бот. <br>
          И в веб-форме, и в диалоге с ботом доступны все возможности системы, поэтому участникам нет <br>
          необходимости переключаться между платформами. При этом программа создает общий <br>
          личный кабинет, и отдельная регистрация для каждой платформы не требуется.`,
          src: require(`@/assets/images/card-franchaisors4.svg`)
        }
      ],
      description: {
        title: `Поддерживает любую механику`,
        paragraphs: [
          `В системе предусмотрено несколько базовых механик. Среди них программа <br>
          лояльности с начислением баллов, регистрация купонов на розыгрыш, <br>
          или мгновенная лотерея. Но возможности этим не ограничены.`,
          `Например, есть функция добавления бонусов за регулярность покупок, <br>
          или многоуровневая система лояльности. Правила могут быть настроены <br>
          под совершенно разную механику.`
        ],
        src: require(`@/assets/images/description5.svg`)
      },
      like: {
        title: `Собственный дизайн программы`,
        paragraph: `Для каждого франчайзора бренд - главная ценность франшизы. Программа имеет определенные шаблоны интерфейсов, которые <br>
        наиболее удобны и понятны пользователям. При этом внешний вид системы настраивается в полном соответствии с вашим <br>
        бренд-буком, а веб-платформа акции можетбыть расположена на вашем домене.`,
        src: require(`@/assets/images/like5.svg`)
      },
      promise: ` Обещаем присылать не более четырех писем в месяц с обзором наших новых возможностей, <br>
      продуктов, предложения`
    };
  }
};
</script>